import { CustomerInfo } from '@/domain/CustomerInfo'
import { AgencyInfo } from '@/domain/AgencyInfo'
import { UserInfo } from '@/domain/UserInfo'
import { RequestDetail } from '@/domain/Request'
import FileData from '@/domain/FileData'
import DateUtils from '@/utils/DateUtils'

/**
 * 報告書
 */
export class Report {
    /** 報告書番号 */
    reportNo = ""
    /** 受付番号 */
    requestNo = ""
    /** 報告書作成日 YYYY-MM-DD */
    reportOn = ""
    /** 件名 */
    subject = ""
    /** 検査依頼種別 */
    requestType = 0
    /** 検体名称 */
    specimenName = ""
    /** 検体識別記号 */
    specimenId = ""
    /** 検査項目名(複数) */
    inspectionNames = ""
    /** 検査分類名(複数：重複なし) */
    classificationNames = ""
    /** 報告書作成者 */
    authorUser = new UserInfo()
    /** 一次承認者 */
    primaryAuthorizerUser = new UserInfo()
    /** 二次承認者 */
    secondaryAuthorizerUser = new UserInfo()
    /** 備考 */
    note = ""
    /** メール送信日時 */
    mailSendAt: string | null = null
    /** 郵送日 YYYY-MM-DD */
    postSendOn: string | null = null
    /** FAX送信日 YYYY-MM-DD */
    faxSendOn: string | null = null
    /** 印刷日時 */
    printAt: string | null = null
    /** NDFP検査依頼ID'*/
    requestId = ""

    /** 依頼明細 */
    details = [new RequestDetail()]

    /** 報告書 */
    reportFile = new FileData()
    /** 添付資料 */
    attachFiles: FileData[] = []

    /** 顧客情報 */
    customerInfo = new CustomerInfo()
    /** 代理店情報 */
    agencyInfo = new AgencyInfo()

    /** 前の報告番号 */
    previousReportNo = ""

    /** 次の報告番号 */
    nextReportNo = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<Report>) {
        Object.assign(this, init)
    }

    /**
     * 複製を作成する
     */
    clone() {
        return new Report(JSON.parse(JSON.stringify(this)));
    }

    /**
     * 宛先の会社が空か
     */
    get isEmptyCustomer() {
        return this.customerInfo.customerPrefectureCode === "" || this.customerInfo.customerCode === "" || this.customerInfo.customerBranchNumber === ""
    }

    /**
     * 代理店経由か
     */
    get hasAgency() {
        return this.agencyInfo.agencyPrefectureCode !== null && this.agencyInfo.agencyCode !== null || this.agencyInfo.agencyBranchNumber !== null
    }

    /**
     * メール送信済みか？
     */
    get isMailSended() {
        return !(this.mailSendAt === null || this.mailSendAt === "")
    }

    /**
     * 郵送済みか？
     */
    get isPostSended() {
        return !(this.postSendOn === null || this.postSendOn === "")
    }

    /**
     * FAX送信済みか？
     */
    get isFaxSended() {
        return !(this.faxSendOn === null || this.faxSendOn === "")
    }

    /**
     * 印刷済みか？
     */
    get isPrinted() {
        return !(this.printAt === null || this.printAt === "")
    }

    /**
     * ロック状態(編集不可)か？
     */
    get isLocked() {
        return false
    }

    /**
     * フィルターキーワードの取得
     */
    get filterKeyword() {
        const dateUtils = DateUtils.instance
        return `${dateUtils.toJapanFormat(this.reportOn)} ${this.requestNo} ${this.customerInfo.customerName} ${this.agencyInfo.agencyName} ${this.specimenName} ${this.specimenId} ${this.inspectionNames} ${this.classificationNames}`
    }

    /**
     * 明細行を削除
     * @param lineIndex
     */
    deleteDeailLine(lineIndex: number) {
        this.details.splice(lineIndex, 1)
    }
}

/**
 * メール送信キュー
 */
export class MailQueue {
    /** TO宛先 */
    to = ""
    /** CC宛先 */
    cc: string | null = null
    /** BCC宛先 */
    bcc: string | null = null
    /** REPLY TO  */
    replyTo: string | null = null
    /** 件名 */
    subject = ""
    /** 本文 */
    content = ""
    /** 報告書番号 */
    reportNos: string[] = []
    /** メール送信日時 */
    mailSendAt: string | null = null

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<MailQueue>) {
        Object.assign(this, init)
    }
}
